import axios from 'axios';

const apiSetting = async ({ method, url, headers = null, data = null }) => {
  try {
    if (!url || typeof url !== 'string' || !url.startsWith('http')) {
      throw new Error('Invalid URL');
    }

    const config = {
      method: method,
      url: url
    };

    if (headers != null) {
      config.headers = headers;
    }

    if (data != null) {
      config.data = data;
    }
    console.log(config);
    const response = await axios(config);
    return response;
  } catch (error) {
    throw error;
  }
};

export default apiSetting;
